import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "300c3f66-0b4b-4117-9b8c-0a34b46df025",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the natural frequency of the moving parts (round to the nearest integer)",
    orientation: "vertical",
    unit: "Hz",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 30,
};
